import { ComparisonOperator, RegexOptions } from "@/libs/builder/models/queries";

type FieldFilterValue = string | number | boolean | Date;

export class BuilderIoQueryBuilder {
  private query: any = {};

  private mergeFieldFilters(fieldName: string, newFilter: any): void {
    this.query[fieldName] = {
      ...(this.query[fieldName] || {}),
      ...newFilter,
    };
  }

  addDateRange(fieldName: string, startDate?: Date, endDate?: Date): BuilderIoQueryBuilder {
    if (!startDate && !endDate) {
      return this;
    }

    const dateFilter: any = {};
    if (startDate) {
      dateFilter[ComparisonOperator.GREATER_OR_EQUAL_THAN] = startDate.getTime();
    }
    if (endDate) {
      dateFilter[ComparisonOperator.LESS_OR_EQUAL_THAN] = endDate.getTime();
    }

    this.mergeFieldFilters(fieldName, dateFilter);

    return this;
  }

  addInArray(fieldName: string, values: FieldFilterValue[]): BuilderIoQueryBuilder {
    return this.addArrayFilter(fieldName, ComparisonOperator.IN, values);
  }

  addAllInArray(fieldName: string, values: FieldFilterValue[]): BuilderIoQueryBuilder {
    return this.addArrayFilter(fieldName, ComparisonOperator.ALL, values);
  }

  addNotInArray(fieldName: string, values: FieldFilterValue[]): BuilderIoQueryBuilder {
    return this.addArrayFilter(fieldName, ComparisonOperator.NOT_IN, values);
  }

  addEquals(fieldName: string, value: FieldFilterValue): BuilderIoQueryBuilder {
    return this.addFilter(fieldName, ComparisonOperator.EQUALS, value);
  }

  addTextSearch(fieldName: string, searchText: string): BuilderIoQueryBuilder {
    const textFilter = {
      [ComparisonOperator.TEXT]: {
        $search: searchText,
      },
    };

    this.mergeFieldFilters(fieldName, textFilter);

    return this;
  }

  addRegexSearch(fieldName: string, regex: string, options?: RegexOptions[]): BuilderIoQueryBuilder {
    const regexFilter: any = {
      [ComparisonOperator.REGEX]: regex,
    };

    if (options && options.length > 0) {
      regexFilter.$options = options.join("");
    }

    this.mergeFieldFilters(fieldName, regexFilter);

    return this;
  }

  addFilter(fieldName: string, operator: ComparisonOperator, value: FieldFilterValue): BuilderIoQueryBuilder {
    if (!value) {
      return this;
    }

    const filter = {
      [operator]: value,
    };
    this.mergeFieldFilters(fieldName, filter);

    return this;
  }

  addArrayFilter(fieldName: string, operator: ComparisonOperator, values: FieldFilterValue[]): BuilderIoQueryBuilder {
    if (!values || values.length === 0) {
      return this;
    }

    const arrayFilter = {
      [operator]: values,
    };
    this.mergeFieldFilters(fieldName, arrayFilter);

    return this;
  }

  build(): any {
    return this.query;
  }
}
